<template>
    <div class="add-event-type">
        <div style="display: flex; justify-content: space-between;align-items: center">
            <h2>Add Offer</h2>
            <el-button type="primary" size="medium" @click="save()">Save</el-button>
        </div>
        <div slot="content">
            <div class="centered vue-loader" style="height: 350px" v-if="loading">
                <vue-loader></vue-loader>
            </div>
            <div v-else class="form p-b-0-label" style="display: flex; justify-content: center">
                <el-form ref="addBusCompany" :model="travel_offer" :rules="formRules"
                         label-position="left"
                         class="form"
                         style="max-width: 500px"
                >
                    <el-form-item label="Hotel name" prop="hotelName">
                        <el-input v-model="travel_offer.hotelName"></el-input>
                    </el-form-item>
                    <el-form-item label="City" prop="city">
                        <el-input v-model="travel_offer.city"></el-input>
                    </el-form-item>
                    <el-form-item label="Country" prop="country">
                        <el-input v-model="travel_offer.country"></el-input>
                    </el-form-item>
                    <el-form-item label="Days" prop="days">
                        <el-select v-model="travel_offer.days" placeholder="Select days" style="width: 100%">
                            <el-option
                                    v-for="day in days"
                                    :key="day"
                                    :label="day"
                                    :value="day">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Date" prop="date">
                        <el-date-picker style="width: 100%" v-model="travel_offer.date"></el-date-picker>
                    </el-form-item>
                    <el-select v-model="photo_option">
                        <el-option label="Facebook link" value="FacebookLink"></el-option>
                        <el-option label="Upload image" value="UploadImage"></el-option>
                    </el-select>


                    <el-form-item label="Photo" prop="photo" v-if="photo_option === 'UploadImage'">
                        <div v-if="travel_offer.photo === null" style="width: 100%">
                            <div @click="onEditPhoto"
                                 style="width: 100%"
                                 class="no-image-container">
                                <div class="no-image-contents" style="width: 100%">
                                    <div>Add image</div>
                                    <i class="el-icon-upload"/>
                                </div>
                            </div>
                        </div>

                    </el-form-item>

                    <el-form-item v-else label="Facebook link">
                        <el-input placeholer="Facebook link" v-model="facebook_photo_link">
                            <el-button slot="append" icon="el-icon-upload"
                                       @click="onFileSelected(facebook_photo_link)"></el-button>
                        </el-input>
                    </el-form-item>


                    <div v-if="travel_offer.photo"
                         style="width: 100%"
                         @click="onEditPhoto"
                         class="image-container">
                        <el-image
                                style=" min-width: 170px;max-width: 500px"
                                :src="travel_offer.photo">
                        </el-image>
                    </div>
                </el-form>

            </div>
        </div>

    </div>
</template>
<script>
    import {mapState} from 'vuex';
    import {LoaderIcon} from 'vue-feather-icons'
    import TravelService from '@/common/services/travel.service'
    import {uploadImageToImgur} from "../../common/services/image.upload.service";

    export default {
        name: "AddTravelOffer",
        components: {
            VueLoader: LoaderIcon
        },
        data() {
            return {
                loading: false,
                travel_offer: {
                    userEmail: this.user_email,
                    hotelName: "",
                    photo: null,
                    city: "",
                    country: "",
                    days: 1,
                    date: "",
                },
                photo_option: 'UploadImage',
                facebook_photo_link: null,
                days: [
                    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20
                ],
                formRules: {
                    // name: {
                    //     required: true,
                    //     trigger: 'change',
                    // },
                    // phoneNumber: {
                    //     required: true,
                    //     trigger: 'change',
                    // },
                    // userEmail: {
                    //     required: true,
                    //     trigger: 'change',
                    // },
                },
            }
        },
        computed: {
            ...mapState({
                user_email: state => state.user.user_email,
            })
        },
        methods: {
            onEditPhoto() {
                let input = document.createElement('input');
                input.type = 'file';
                input.click();
                input.onchange = e => {
                    let file = e.target.files[0];
                    this.onFileSelected(file);
                }
            },
            async onFileSelected(image) {
                this.loading = true;
                let formData = new FormData();
                formData.append('image', image);
                let response = await uploadImageToImgur(image);
                if (!response.ok) {
                    this.$notify.error({
                        title: `Failed to upload image`,
                        message: `Failed to upload image`
                    });
                    return
                }
                let responseJson = await response.json();
                this.travel_offer.photo = responseJson.data.link;
                this.$notify.success({
                    title: `Upload image`,
                    message: `Successfully upload image`
                });
                this.loading = false
            },
            save() {
                this.$refs['addBusCompany'].validate(valid => {
                    if (valid) {
                        this.loading = true;
                        this.travel_offer.userEmail = this.user_email;
                        TravelService.addTravelOffers(this.travel_offer).then(() => {
                            this.$notify.success({
                                title: `Travel`,
                                message: 'Successfully added travel offer'
                            });
                            this.$emit('close')
                        }).catch(error => {
                            this.$notify.error({
                                title: `Failed to add travel offer`,
                                message: error.response.data.message
                            });
                        }).finally(() => this.loading = false)
                    } else {
                        return false;
                    }
                })
            },
        },beforeMount() {
            console.log(this.user_email)
        }
    }
</script>
<style scoped lang="scss">
    .add-event-type {
        h3 {
            margin: 0;
        }

        padding: 20px;

        .add-buttons {
            display: flex;
            justify-content: space-between;
            margin-top: 10px;

            .add-button {
                background-color: #efefef;
                border: 1px solid lightgray;
                width: 100%;
                padding: 10px 0;
                cursor: pointer;
            }
        }

        .form {
            height: 350px;
            min-width: 500px;
            margin-bottom: 20px;

            @media screen  and (max-width: 768px){
                min-width: 200px;
            }

            .no-image-container {
                background-color: #f8f8f8;
                display: flex;
                width: 100%;
                height: 150px;
                cursor: pointer;
                border-radius: 5px;
                padding: 30px;

                .no-image-contents {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    flex-direction: column;
                    border-radius: 4px;
                }
            }

            .image-container {
                display: flex;
                justify-content: center;
                border: 1px solid #DCDFE6;
                border-radius: 4px;
                cursor: pointer;

            }

            .file-select {

            }

            .avatar-uploader .el-upload {
                border: 1px dashed #d9d9d9;
                border-radius: 6px;
                cursor: pointer;
                position: relative;
                overflow: hidden;
            }

            .avatar-uploader .el-upload:hover {
                border-color: #409EFF;
            }

            .avatar-uploader-icon {
                font-size: 28px;
                color: #8c939d;
                height: 178px;
                line-height: 178px;
                text-align: center;
            }

            .avatar {
                width: 178px;
                height: 178px;
                display: block;
            }

        }

        .footer-btn {
            display: flex;
            justify-content: flex-end;
        }

    }
</style>
